import { Component, OnInit } from '@angular/core';
import { HttpHeaders,HttpClient } from '@angular/common/http';
import { takeUntil, map } from 'rxjs/operators';
import * as printJS from 'print-js';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { InwardService } from 'src/app/shared/services/inward.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { Subject } from 'rxjs';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { OutwardStatus } from 'src/app/Enums/outwardEnum';
import { RoleStatus } from 'src/app/Enums/roleEnum';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {
  userName: string;
  response = '';
  roleId: any;
  inwardList: any;
  outwardList: any;
  InwardStatus = InwardStatus;
  OutwardStatus = OutwardStatus;

  //Inward Requests
  created: number = 0;
  returnableCreated: number = 0;
  nonreturnableCreated: number = 0;
  imcreated: number = 0;

  received: number = 0;
  returnableReceived: number = 0;
  nonreturnableReceived: number = 0;
  imreceived: number = 0;

  challan: number = 0;
  returnableChallan: number = 0;
  nonreturnableChallan: number = 0;
  imchallan: number = 0;

  checked: number = 0;
  returnableChecked: number = 0;
  nonreturnableChecked: number = 0;
  imchecked: number = 0;

  declined: number = 0;
  returnableDeclined: number = 0;
  nonreturnableDeclined: number = 0;
  imdeclined: number = 0;

  //Outward Requests
  ocreated: number = 0;
  oreturnableCreated: number = 0;
  internalCreated:number = 0;
  ononreturnableCreated: number = 0;

  odeclined: number = 0;
  oreturnableDeclined: number = 0;
  internalDeclined: number = 0;
  ononreturnableDeclined: number = 0;

  oreceived: number = 0;
  oreturnableReceived: number = 0;
  internalReceived: number = 0;
  ononreturnableReceived: number = 0;

  laappr1: number = 0;
  returnablelaappr1: number = 0;
  internallaappr1: number = 0;
  nonreturnablelaappr1: number = 0;

  laappr2: number = 0;
  returnablelaappr2: number = 0;
  internallaappr2: number = 0;
  nonreturnablelaappr2: number = 0;

  supappr: number = 0;
  returnablesupappr: number = 0;
  internalsupappr: number = 0;
  nonreturnablesupappr: number = 0;

  cancelled: number = 0;
  returnablecancelled: number = 0;
  internalcancelled: number = 0;
  nonreturnablecancelled: number = 0;

  printpass: number = 0;
  returnableprintpass: number = 0;
  internalprintpass: number = 0;
  nonreturnableprintpass: number = 0;

  private service_URL: any;

  flag1: boolean = true;
  flag2: boolean = true;
  showLoader1: boolean = true;
  showLoader2: boolean = true;

  roleSuperAdmin: any;
  roleAdmin: any;
  roleSecuritySupervisor: any;
  roleUser: any;
  private unsubscribe$ =new Subject<void>();

  constructor(private _dataContextService: DataContextService,private toast: ToastrService,private loaderService: LoaderService,private inwardService: InwardService,
    private router: Router,private route: ActivatedRoute)
  {
    this.roleSuperAdmin = RoleStatus.SuperAdmin;
    this.roleAdmin = RoleStatus.Admin;
    this.roleSecuritySupervisor = RoleStatus.SecuritySupervisior;
    this.roleUser = RoleStatus.User;

    this.service_URL = ConstantsService;
  }

  ngOnInit(){
    this.userName  =  localStorage.getItem('name');
    this.roleId = localStorage.getItem('roleID');

    this._dataContextService.get<any>(this.service_URL.InwardDetails.GetInwardDashboardData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res)=>{
      // console.log(res);
      this.inwardList = res;

      // Created 
      var created = this.inwardList.filter((rec) => {
        return rec.statusId == InwardStatus.Created
      })
      this.created = created.length;

      var rcreated = created.filter((res) => {
        return res.registrationType == InwardStatus.Returnable
      })
      this.returnableCreated = rcreated.length;

      var nrcreated = created.filter((res) => {
        return res.registrationType == InwardStatus.NonReturnable
      })
      this.nonreturnableCreated = nrcreated.length;

      var icreated = created.filter((res) => {
        return res.registrationType == InwardStatus.InternalMovement
      })
      this.imcreated = icreated.length;

      // Checked
      var checked = this.inwardList.filter((rec) => {
        return rec.statusId == InwardStatus.Checked
      })
      this.checked = checked.length;

      var rchecked = checked.filter((res) => {
        return res.registrationType == InwardStatus.Returnable
      })
      this.returnableChecked = rchecked.length;

      var nrchecked = checked.filter((res) => {
        return res.registrationType == InwardStatus.NonReturnable
      })
      this.nonreturnableChecked = nrchecked.length;

      var ichecked = checked.filter((res) => {
        return res.registrationType == InwardStatus.InternalMovement
      })
      this.imchecked = ichecked.length;

      // Challan Uploaded
      var challan = this.inwardList.filter((rec) => {
        return rec.statusId == InwardStatus.ChallanUploaded
      })
      this.challan = challan.length;

      var rchallan = challan.filter((res) => {
        return res.registrationType == InwardStatus.Returnable
      })
      this.returnableChallan = rchallan.length;

      var nrchallan = challan.filter((res) => {
        return res.registrationType == InwardStatus.NonReturnable
      })
      this.nonreturnableChallan = nrchallan.length;

      var ichallan = challan.filter((res) => {
        return res.registrationType == InwardStatus.InternalMovement
      })
      this.imchallan = ichallan.length;

      // Received
      var received = this.inwardList.filter((rec) => {
        return rec.statusId == InwardStatus.Received
      })
      this.received = received.length;

      var rreceived = received.filter((res) => {
        return res.registrationType == InwardStatus.Returnable
      })
      this.returnableReceived = rreceived.length;

      var nrreceived = received.filter((res) => {
        return res.registrationType == InwardStatus.NonReturnable
      })
      this.nonreturnableReceived = nrreceived.length;

      var ireceived = received.filter((res) => {
        return res.registrationType == InwardStatus.InternalMovement
      })
      this.imreceived = ireceived.length;

      // Declined
      var declined = this.inwardList.filter((rec) => {
        return rec.statusId == InwardStatus.Declined
      })
      this.declined = declined.length;

      var rdeclined = declined.filter((res) => {
        return res.registrationType == InwardStatus.Returnable
      })
      this.returnableDeclined = rdeclined.length;
      
      var nrdeclined = declined.filter((res) => {
        return res.registrationType == InwardStatus.NonReturnable
      })
      this.nonreturnableDeclined = nrdeclined.length;

      var ideclined = declined.filter((res) => {
        return res.registrationType == InwardStatus.InternalMovement
      })
      this.imdeclined = ideclined.length;

      // console.log("Created",created);
      // console.log("Returnable Created",rcreated);
      // console.log("Non-Returnable Created",nrcreated);

      // console.log("Checked",checked);
      // console.log("Returnable Checked",rchecked);
      // console.log("Non-Returnable Checked",nrchecked);
      
      // console.log("Challan Uploaded",challan);
      // console.log("Returnable Challan Uploaded",rchallan);
      // console.log("Non-Returnable Challan Uploaded",nrchallan);
      
      // console.log("Received",received);
      // console.log("Returnable Received",rreceived);
      // console.log("Non-Returnable Received",nrreceived);
      
      // console.log("Declined",declined);
      // console.log("Returnable Challan Uploaded",rdeclined);
      // console.log("Non-Returnable Challan Uploaded",nrdeclined);
    },(error)=>{
      this.toast.error("Something Went Wrong !");
    },
    () => {
      this.showLoader1 = false;
    }
    )

    this._dataContextService.get<any>(this.service_URL.OutwardDetails.GetOutwardDashboardData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      this.outwardList = res;

      // Created 
      var ocreated = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.Created
      })
      this.ocreated = ocreated.length;

      var rcreated = ocreated.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.oreturnableCreated = rcreated.length;

      var icreated = ocreated.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalCreated = icreated.length;

      var nrcreated = ocreated.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.ononreturnableCreated = nrcreated.length;

      // Received
      var oreceived = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.Received
      })
      this.oreceived = oreceived.length;

      var rreceived = oreceived.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.oreturnableReceived = rreceived.length;

      var ireceived = oreceived.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalReceived = ireceived.length;

      var nrreceived = oreceived.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.ononreturnableReceived = nrreceived.length;

      // Declined
      var odeclined = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.Declined
      })
      this.odeclined = odeclined.length;

      var rdeclined = odeclined.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.oreturnableDeclined = rdeclined.length;

      var ideclined = odeclined.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalDeclined = ideclined.length;
      
      var nrdeclined = odeclined.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.ononreturnableDeclined = nrdeclined.length;

      // Cancelled
      var cancelled = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.Cancelled
      })
      this.cancelled = cancelled.length;

      var rcancelled = cancelled.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.returnablecancelled = rcancelled.length;

      var icancelled = cancelled.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalcancelled = icancelled.length;
      
      var nrcancelled = cancelled.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.nonreturnablecancelled = nrcancelled.length;

      //Print Pass
      var pp = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.PrintPass
      })
      this.printpass = pp.length;

      var rpp = pp.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.returnableprintpass = rpp.length;

      var ipp = pp.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalprintpass = ipp.length;
      
      var nrpp = pp.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.nonreturnableprintpass = nrpp.length;

      //LA Approver 1
      var laap1 = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.LAapprover1
      })
      this.laappr1 = laap1.length;

      var rlaap1 = laap1.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.returnablelaappr1 = rlaap1.length;

      var ilaap1 = laap1.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internallaappr1 = ilaap1.length;
      
      var nrlaap1 = laap1.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.nonreturnablelaappr1 = nrlaap1.length;

      //LA Approver 2
      var laap2 = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.LAapprover2
      })
      this.laappr2 = laap2.length;

      var rlaap2 = laap2.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.returnablelaappr2 = rlaap2.length;

      var ilaap2 = laap2.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internallaappr2 = ilaap2.length;
      
      var nrlaap2 = laap2.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.nonreturnablelaappr2 = nrlaap2.length;

      //Supervisor Approval
      var supapp = this.outwardList.filter((rec) => {
        return rec.statusId == OutwardStatus.Supervisor
      })
      this.supappr = supapp.length;

      var rsupapp = supapp.filter((res) => {
        return res.requestTypeId == OutwardStatus.Returnable
      })
      this.returnablesupappr = rsupapp.length;

      var isupapp = supapp.filter((res) => {
        return res.requestTypeId == OutwardStatus.InternalMovement
      })
      this.internalsupappr = isupapp.length;
      
      var nrsupapp = supapp.filter((res) => {
        return res.requestTypeId == OutwardStatus.NonReturnable
      })
      this.nonreturnablesupappr = nrsupapp.length;

    },(error)=>{
      this.toast.error("Something Went Wrong !");
    },
    () => {
      this.showLoader2 = false;
    })

    // if(this.flag1 && this.flag2){
    //   this.showLoader = false;
    // }
  }

  Print()
  {
 
var res = 'JVBERi0xLjMNCiXi48/TDQoNCjEgMCBvYmoNCjw8DQovVHlwZSAvQ2F0YWxvZw0KL091dGxpbmVzIDIgMCBSDQovUGFnZXMgMyAwIFINCj4+DQplbmRvYmoNCg0KMiAwIG9iag0KPDwNCi9UeXBlIC9PdXRsaW5lcw0KL0NvdW50IDANCj4+DQplbmRvYmoNCg0KMyAwIG9iag0KPDwNCi9UeXBlIC9QYWdlcw0KL0NvdW50IDINCi9LaWRzIFsgNCAwIFIgNiAwIFIgXSANCj4+DQplbmRvYmoNCg0KNCAwIG9iag0KPDwNCi9UeXBlIC9QYWdlDQovUGFyZW50IDMgMCBSDQovUmVzb3VyY2VzIDw8DQovRm9udCA8PA0KL0YxIDkgMCBSIA0KPj4NCi9Qcm9jU2V0IDggMCBSDQo+Pg0KL01lZGlhQm94IFswIDAgNjEyLjAwMDAgNzkyLjAwMDBdDQovQ29udGVudHMgNSAwIFINCj4+DQplbmRvYmoNCg0KNSAwIG9iag0KPDwgL0xlbmd0aCAxMDc0ID4+DQpzdHJlYW0NCjIgSg0KQlQNCjAgMCAwIHJnDQovRjEgMDAyNyBUZg0KNTcuMzc1MCA3MjIuMjgwMCBUZA0KKCBBIFNpbXBsZSBQREYgRmlsZSApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY4OC42MDgwIFRkDQooIFRoaXMgaXMgYSBzbWFsbCBkZW1vbnN0cmF0aW9uIC5wZGYgZmlsZSAtICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjY0LjcwNDAgVGQNCigganVzdCBmb3IgdXNlIGluIHRoZSBWaXJ0dWFsIE1lY2hhbmljcyB0dXRvcmlhbHMuIE1vcmUgdGV4dC4gQW5kIG1vcmUgKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NTIuNzUyMCBUZA0KKCB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDYyOC44NDgwIFRkDQooIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjE2Ljg5NjAgVGQNCiggdGV4dC4gQW5kIG1vcmUgdGV4dC4gQm9yaW5nLCB6enp6ei4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNjA0Ljk0NDAgVGQNCiggbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDU5Mi45OTIwIFRkDQooIEFuZCBtb3JlIHRleHQuIEFuZCBtb3JlIHRleHQuICkgVGoNCkVUDQpCVA0KL0YxIDAwMTAgVGYNCjY5LjI1MDAgNTY5LjA4ODAgVGQNCiggQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA1NTcuMTM2MCBUZA0KKCB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBFdmVuIG1vcmUuIENvbnRpbnVlZCBvbiBwYWdlIDIgLi4uKSBUag0KRVQNCmVuZHN0cmVhbQ0KZW5kb2JqDQoNCjYgMCBvYmoNCjw8DQovVHlwZSAvUGFnZQ0KL1BhcmVudCAzIDAgUg0KL1Jlc291cmNlcyA8PA0KL0ZvbnQgPDwNCi9GMSA5IDAgUiANCj4+DQovUHJvY1NldCA4IDAgUg0KPj4NCi9NZWRpYUJveCBbMCAwIDYxMi4wMDAwIDc5Mi4wMDAwXQ0KL0NvbnRlbnRzIDcgMCBSDQo+Pg0KZW5kb2JqDQoNCjcgMCBvYmoNCjw8IC9MZW5ndGggNjc2ID4+DQpzdHJlYW0NCjIgSg0KQlQNCjAgMCAwIHJnDQovRjEgMDAyNyBUZg0KNTcuMzc1MCA3MjIuMjgwMCBUZA0KKCBTaW1wbGUgUERGIEZpbGUgMiApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY4OC42MDgwIFRkDQooIC4uLmNvbnRpbnVlZCBmcm9tIHBhZ2UgMS4gWWV0IG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NzYuNjU2MCBUZA0KKCBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSB0ZXh0LiBBbmQgbW9yZSApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY2NC43MDQwIFRkDQooIHRleHQuIE9oLCBob3cgYm9yaW5nIHR5cGluZyB0aGlzIHN0dWZmLiBCdXQgbm90IGFzIGJvcmluZyBhcyB3YXRjaGluZyApIFRqDQpFVA0KQlQNCi9GMSAwMDEwIFRmDQo2OS4yNTAwIDY1Mi43NTIwIFRkDQooIHBhaW50IGRyeS4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gQW5kIG1vcmUgdGV4dC4gKSBUag0KRVQNCkJUDQovRjEgMDAxMCBUZg0KNjkuMjUwMCA2NDAuODAwMCBUZA0KKCBCb3JpbmcuICBNb3JlLCBhIGxpdHRsZSBtb3JlIHRleHQuIFRoZSBlbmQsIGFuZCBqdXN0IGFzIHdlbGwuICkgVGoNCkVUDQplbmRzdHJlYW0NCmVuZG9iag0KDQo4IDAgb2JqDQpbL1BERiAvVGV4dF0NCmVuZG9iag0KDQo5IDAgb2JqDQo8PA0KL1R5cGUgL0ZvbnQNCi9TdWJ0eXBlIC9UeXBlMQ0KL05hbWUgL0YxDQovQmFzZUZvbnQgL0hlbHZldGljYQ0KL0VuY29kaW5nIC9XaW5BbnNpRW5jb2RpbmcNCj4+DQplbmRvYmoNCg0KMTAgMCBvYmoNCjw8DQovQ3JlYXRvciAoUmF2ZSBcKGh0dHA6Ly93d3cubmV2cm9uYS5jb20vcmF2ZVwpKQ0KL1Byb2R1Y2VyIChOZXZyb25hIERlc2lnbnMpDQovQ3JlYXRpb25EYXRlIChEOjIwMDYwMzAxMDcyODI2KQ0KPj4NCmVuZG9iag0KDQp4cmVmDQowIDExDQowMDAwMDAwMDAwIDY1NTM1IGYNCjAwMDAwMDAwMTkgMDAwMDAgbg0KMDAwMDAwMDA5MyAwMDAwMCBuDQowMDAwMDAwMTQ3IDAwMDAwIG4NCjAwMDAwMDAyMjIgMDAwMDAgbg0KMDAwMDAwMDM5MCAwMDAwMCBuDQowMDAwMDAxNTIyIDAwMDAwIG4NCjAwMDAwMDE2OTAgMDAwMDAgbg0KMDAwMDAwMjQyMyAwMDAwMCBuDQowMDAwMDAyNDU2IDAwMDAwIG4NCjAwMDAwMDI1NzQgMDAwMDAgbg0KDQp0cmFpbGVyDQo8PA0KL1NpemUgMTENCi9Sb290IDEgMCBSDQovSW5mbyAxMCAwIFINCj4+DQoNCnN0YXJ0eHJlZg0KMjcxNA0KJSVFT0YNCg==';  
  const blobPdfFromBase64String = base64String  => {
    const byteArray = Uint8Array.from(
      atob(base64String)
        .split('')
        .map(char => char.charCodeAt(0))
    );
   return new Blob([byteArray], { type: 'application/pdf' });
 };
 var asd = blobPdfFromBase64String(res);
 // var result = new Blob([res], { type: 'application/pdf' })
 const blobUrl = URL.createObjectURL(asd);
 printJS(blobUrl);
 
 
}

}
